import Modal from "./Modal.jsx";

export default function ConfirmDialog({
  open,
  title = "Confirm action",
  message,
  confirmLabel = "Confirm",
  loading = false,
  onCancel,
  onConfirm
}) {
  return (
    <Modal open={open} title={title} onClose={onCancel} size="sm">
      <p className="muted">{message}</p>
      <div className="form-actions">
        <button className="btn btn-ghost" type="button" onClick={onCancel} disabled={loading}>
          Cancel
        </button>
        <button className="btn btn-danger" type="button" onClick={onConfirm} disabled={loading}>
          {loading ? <span className="spinner" /> : null}
          {confirmLabel}
        </button>
      </div>
    </Modal>
  );
}
